import React, { useEffect, useState } from "react";
import "./AddLessonForm.css";
import TextFieldInput from "../../../Atoms/Inputs/TextField/TextFieldInput";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Typography } from "@mui/material";
import TextArea from "../../../Atoms/Inputs/TextArea/TextArea";
import useEdit from "../../../../Hooks/useEdit";
import useSave from "../../../../Hooks/useSave";
import { BaseURL, courseURL } from "../../../../Hooks/URL";
import AddIcon from "@mui/icons-material/Add";
import { Formik } from "formik";
import * as Yup from "yup";
import { images } from "../../../../Assets/assetsHelper";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import FileAttachmentInput from "../../../Molecules/FileAttachmentInput/FileAttachmentInput";

const CourseSchema = Yup.object().shape({
  title: Yup.string().required("Lesson name required !!"),
  content: Yup.string().required("Content required !!"),
  number: Yup.string().required("Number required !!"),
});

function AddLessonForm({ Edit = false, lesson, course, url }) {
  // const [file, setFile] = useState("");
  const navigate = useNavigate();
  const [newObject, setNewObject] = useState({});
  const [existingAttachments, setExistingAttachments] = useState(
    lesson?.attachments?.map((file, index) => ({
      id: file?.id,
      file: file?.filePath,
      name: file?.name,
      size: 0,
      type: "application/octet-stream",
      isExisting: true,
    })) ?? []
  );
  const [newAttachments, setNewAttachments] = useState([]);
  const [deletedAttachmentIds, setDeletedAttachmentIds] = useState([]);
  const [goEdit, setGoEdit] = useState(false);
  const [goSave, setGoSave] = useState(false);
  const { state, loading: editLoading } = useEdit(
    `${courseURL}/${course?.id}/lessons/${lesson?.id}`,
    goEdit,
    setGoEdit,
    newObject,
    true, // Enable file upload for edit
    true // Enable file upload handling
  );
  const { saveState, loading: addLoading } = useSave({
    url: `${courseURL}/${course?.id}/lessons`,
    goSave,
    setGoSave,
    newObject,
    isImage: true,
  });

  // Initialize attachments when course data changes (for edit mode)
  useEffect(() => {
    if (lesson && Edit) {
      setExistingAttachments(
        lesson?.attachments?.map((file, index) => ({
          id: file?.id,
          file: file?.filePath,
          name: file?.name,
          size: 0,
          type: "application/octet-stream",
          isExisting: true,
        })) ?? []
      );
      setNewAttachments([]);
      setDeletedAttachmentIds([]);
    }
  }, [lesson, Edit]);

  useEffect(() => {
    if (state.dataRes.status == "success") {
      navigate(`/programs/${course?.id}/lessons/${lesson?.id}`);
    }
  }, [state]);

  useEffect(() => {
    if (saveState.dataRes.status == "success") {
      navigate(`/programs/${course?.id}`);
    }
  }, [saveState]);

  return (
    <div className="CourseSmallFormWrapper">
      <Formik
        initialValues={{
          title: Edit ? lesson?.title ?? "" : "",
          content: Edit ? lesson?.content ?? "" : "",
          number: Edit ? lesson?.number ?? 0 : 0,
        }}
        validationSchema={CourseSchema}
        onSubmit={(values) => {
          if (Edit) {
            const newAttachmentsFiles = newAttachments.map((att) => att.file);
            const newAttachmentsNames = newAttachments.map((att) => att.name);

            const newObj = {
              ...values,
              attachmentsFiles: newAttachmentsFiles,
              deletedAttachmentsIds: deletedAttachmentIds,
              attachmentsNames: newAttachmentsNames,
            };

            setNewObject(newObj);
            setGoEdit(true);
          } else {
            const allAttachments = [...existingAttachments, ...newAttachments];
            const attachmentsFiles = allAttachments.map((att) => att.file);
            const attachmentsNames = allAttachments.map((att) => att.name);

            setNewObject({
              ...values,
              attachmentsFiles: attachmentsFiles,
              attachmentsNames: attachmentsNames,
            });
            setGoSave(true);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="CourseFormContainer">
              <div className="LeftForm">
                {/*  <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                     <Typography
                      style={{ fontWeight: "500", marginBottom: "10px" }}
                    >
                      Program Logo:
                    </Typography>
                    <Button
                      component="label"
                      variant="contained"
                      style={{ marginBottom: "20px" }}
                      startIcon={<CloudUploadIcon />}
                      className="ImageInputButton"
                    >
                      Upload file
                      <input
                        accept="image/*"
                        className={"ImageInput"}
                        id="contained-button-file"
                        type="file"
                        onChange={handleUploadClick}
                      />
                    </Button>
                  </div>
                  <img
                    src={file}
                    style={{
                      width: "120px",
                      maxHeight: "120px",
                    }}
                  />
                  </div>*/}
                <label className="aboutLabel" style={{ marginBottom: "3px" }}>
                  Lesson Name:
                </label>
                <TextFieldInput
                  fullWidth
                  type="text"
                  placeholder={"Enter Lesson Name"}
                  className="Input"
                  // label={"Program Name"}
                  name={"title"}
                  change={handleChange}
                  blur={handleBlur}
                  newValue={values.title}
                />

                {errors.title && touched.title && errors.title && (
                  <p className="error">
                    {errors.title && touched.title && errors.title}
                  </p>
                )}

                <label className="aboutLabel" style={{ marginBottom: "3px" }}>
                  Lesson Number:
                </label>
                <TextFieldInput
                  fullWidth
                  type="number"
                  placeholder={"Enter Lesson Number"}
                  className="Input"
                  // label={"Program Name"}
                  name={"number"}
                  change={handleChange}
                  blur={handleBlur}
                  newValue={values.number}
                />

                {errors.number && touched.number && errors.number && (
                  <p className="error">
                    {errors.number && touched.number && errors.number}
                  </p>
                )}

                <label className="aboutLabel">Lesson Content:</label>
                <TextArea
                  style={{ marginBottom: "20px" }}
                  classes="textAreaInput"
                  label={"Content"}
                  name={"content"}
                  change={handleChange}
                  blur={handleBlur}
                  newValue={values.content}
                />
                {errors.content && touched.content && errors.content && (
                  <p className="error">
                    {errors.content && touched.content && errors.content}
                  </p>
                )}

                {/* Attachments Section */}
                <FileAttachmentInput
                  existingAttachments={existingAttachments}
                  newAttachments={newAttachments}
                  deletedAttachmentIds={deletedAttachmentIds}
                  onAttachmentUpload={(files) => {
                    const newFiles = files.map((file) => ({
                      file: file,
                      name: file.name,
                      size: file.size,
                      type: file.type,
                      isExisting: false,
                    }));
                    setNewAttachments((prev) => [...prev, ...newFiles]);
                  }}
                  onRemoveAttachment={(index, isExisting) => {
                    if (isExisting) {
                      setExistingAttachments((prev) =>
                        prev.filter((_, idx) => idx !== index)
                      );
                    } else {
                      setNewAttachments((prev) =>
                        prev.filter((_, idx) => idx !== index)
                      );
                    }
                  }}
                  onUpdateDeletedIds={setDeletedAttachmentIds}
                  onUpdateExistingAttachments={setExistingAttachments}
                  onUpdateNewAttachments={setNewAttachments}
                  maxFiles={5}  
                  label="Lesson Attachments:"
                  accept="*/*"
                  disabled={false}
                  baseURL={BaseURL}
                />
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                className="actionButton primary addButton"
                onClick={handleSubmit}
                disabled={Edit ? editLoading : addLoading}
              >
                {Edit ? (
                  editLoading ? (
                    <PulseLoader color="white" size={8} />
                  ) : (
                    "Edit"
                  )
                ) : addLoading ? (
                  <PulseLoader color="white" size={8} />
                ) : (
                  "Add"
                )}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default AddLessonForm;
